import React from 'react'

export const SubDomainContext = React.createContext(
  {}
)
